import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Radio } from 'antd';
// Local Deps
import NFButton from '../../../../components/primitives/NFButton';
import msgs from '../../../../config/messages';

// import Loading from '../../components/Loading';
function CollectCage({
  setRegistatrationFlow,
  onSubmit,
  onCancel,
  currentFlow,
}) {
  const radioStyle = {
    fontSize: '16px',
  };

  return (
    <div>
      <Row style={{ flexWrap: 'nowrap' }}>
        <Col style={{ marginTop: '16px' }}>
          {/* <!-- LOADING --> */}
          {/* <!-- CONTENT --> */}
          <div className="nf-registration__content">
            <Row className="nf-row--justify-end" />
            {/* <!-- USERS GRID --> */}
            <div className="nf-registration__layout">
              <Radio.Group
                onChange={setRegistatrationFlow}
                value={currentFlow}
              >
                <div className="registration-radio-wrapper">
                  <Radio style={radioStyle} value="new">
                    Organization
                  </Radio>
                  <div className="registration-option-info">
                    Select this registration option if you are a new organization not <i><b>registered </b></i>
                    in the ICON portal and will serve as the administrator for your
                    organization or business. <i>(Please be prepared to provide company Cage
                      Code, NAICS, legal entity name, and address)</i>
                  </div>
                </div>
                <div className="registration-radio-wrapper">
                  <Radio style={radioStyle} value="industry">
                    Industry User
                  </Radio>
                  <div className="registration-option-info">
                    Select this registration option to add user(s) if your organization is <i><b>currently</b></i> registered in the ICON portal.
                    <i>
                      <br />(If you are not sure that your organization is registered or need assistance, contact support@nffs.org or support@iconportal.com)</i>
                  </div>
                </div>
                <div className="registration-radio-wrapper">
                  <Radio style={radioStyle} value="gov">
                    Government Employee or Government Contractor
                  </Radio>
                  <div className="registration-option-info">
                    Select this registration option if you are a government employee or subcontractor of a U.S government agency.
                    <i>
                      <br />(Users must have a <b>.mil</b> email address to choose this option)</i>
                  </div>
                </div>
                {/* <div className="registration-radio-wrapper">
                  <Radio style={radioStyle} value="gov-without-procurement">
                    Government Employee or Government Contractor Without
                    RFQ Capabilities
                  </Radio>
                  <p className="nf-radio-text">I am a Government Employee/Contractor who DOES NOT have RFQ Capabilities for my Agency. I will be using ICON for research on Industry Tooling and Supplier Capabilities only.</p>
                </div>
                <div className="registration-radio-wrapper">
                  <Radio style={radioStyle} value="gov-with-procurement">
                    Government Employee or Government Contractor With
                    RFQ Capabilities
                  </Radio>
                  <p className="nf-radio-text">I am a Government Employee/contractor who HAS RFQ Capabilities for my Agency. I want to be able to interact directly with ICON Industry partners in order to facilitate procurement actions.</p>
                </div> */}
              </Radio.Group>
              <div className="nf-registration--wrapper">
                <div className="nf-registration__buttons">
                  <NFButton
                    className="nf-button--gray-border"
                    style={{ marginRight: '16px' }}
                    onClick={() => {
                      onCancel(true);
                    }}
                  >
                    {msgs.Form.cancelButton}
                  </NFButton>
                  <NFButton
                    disabled={!currentFlow}
                    className="nf-button--form nf-button--orange"
                    type="submit"
                    onClick={() => {
                      onSubmit();
                    }}
                  >
                    {msgs.Form.continueButton}
                  </NFButton>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

CollectCage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  currentFlow: PropTypes.string.isRequired,
  setRegistatrationFlow: PropTypes.func.isRequired,
};

CollectCage.defaultProps = {};

export default CollectCage;




// WEBPACK FOOTER //
// ./src/pages/Registration/subComponents/InitialRequest/InitialRequest.jsx